<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftInfoPanel from '../../../../../../shifts/components/panels/ShiftInfoPanel.vue'
import { Shift } from '../../../../../../shifts/models/shift'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, shift } = defineProps<{
  siteId: SiteID
  shift: Shift
}>()
</script>

<template>
  <ShiftInfoPanel :site-id="siteId" :shift="shift" />
</template>
